import { render, staticRenderFns } from "./OpportunityPriceCreated.vue?vue&type=template&id=25de7b62"
import script from "./OpportunityPriceCreated.vue?vue&type=script&lang=js"
export * from "./OpportunityPriceCreated.vue?vue&type=script&lang=js"
import style0 from "./OpportunityPriceCreated.vue?vue&type=style&index=0&id=25de7b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_clean-css_fb1138f4c37e5532632f307186fea031/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports